import Qs from "qs";
import { useCallback } from "react";
import { useHistory } from "react-router-dom";

/**
 * Remove parameters from the URL.
 * @returns Function to remove parameters.
 */
export const useRemoveUrlParameters = () => {
    const { push } = useHistory();

    const removeUrlParameters = useCallback(
        (parameters: string[]) => {
            const current = Qs.parse(window.location.search, { ignoreQueryPrefix: true });

            const updatedParameters = Object.fromEntries(
                Object.entries(current).filter(([searchEntryKey]) => !parameters.includes(searchEntryKey))
            );
            push({ search: Qs.stringify(updatedParameters, { addQueryPrefix: true, arrayFormat: "repeat" }) });
        },
        [push]
    );

    return removeUrlParameters;
};
